import { makeStyles } from '@mui/styles';

const useHomePageStyle = makeStyles(() => ({
  root: {
    minHeight: '89vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  profileContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '80%',
    marginTop: 'auto',
    marginBottom: 'auto',
    zIndex: 2,
  },
  profileContainerMobile: {
    height: '70% !important',
  },
  avatar: {
    width: 'min(200px, 16vw)',
    height: 'min(200px, 16vw)',
    minWidth: 100,
    minHeight: 100,
    borderRadius: '50% !important',
    objectFit: 'cover !important',
    marginBottom: 20,
  },
  name: {
    fontSize: 'max(3vw, 24px) !important',
    fontFamily: 'Lato !important',
    marginBottom: 20,
  },
  description: {
    fontSize: 'max(2vw, 20px) !important',
    fontFamily: 'Lato !important',
    textAlign: 'center !important',
  },
  links: {
    display: 'flex',
    columnGap: 10,
    marginTop: 20,
  },
  link: {
    '&:hover': {
      color: '#8CB4FF',
    },
  },
}));

export default useHomePageStyle;
